import React from "react";
import {Slide, SlideProps, useScrollTrigger} from "@material-ui/core";

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
    extraTrigger?: boolean;
    direction: SlideProps["direction"];
    withImage?: boolean;
}

export function HideOnScroll(props: Props) {
    const {children} = props;
    const trigger = useScrollTrigger();

    /* const classes = useStyles();*/

    const showChildren = !Boolean(props.extraTrigger) && !trigger;

    return (
        <Slide appear={false} direction={props.direction} in={showChildren}>
            {children}
        </Slide>
    );
}
